module.exports = __webpack_public_path__ + "img/icon-MA-Attendance.8e8ed35e.png";